import axios from "../axios-instance";
import { fallBackErrorMessage } from "../constants/event";
import { getLoggedInUserId } from "../utils/authHelper";
import { SET_USER_AND_PLAN_DETAILS } from "./types";

/**
 * Get user and plan details
 * @param {*} options
 * @return
 */
export const getUserAndPlanDetails = (options) => (dispatch, getState) => {
  const { subscription } = getState();
  const { onSuccess, onError } = options || {};
  axios
    .get(`user-details`)
    .then((res) => {
      const { data: resData } = res || {};
      const { data: details } = resData || {};

      axios
        .get("/admin/plans")
        .then((response) => {
          let userPlan = null;
          response.data.map((plan) => {
            if (plan.id === subscription.userPlan.plan_id) {
              userPlan = {
                ...subscription.userPlan,
                monthly_price: plan.monthly_price,
              };
            }
          });
          dispatch({
            type: SET_USER_AND_PLAN_DETAILS,
            payload: {
              userPlan: {
                plan_id: details.plan_id,
                plan_period_type: details.plan_period_type,
                plan_type: details.plan_type,
                is_paid_subscription: details.is_paid_subscription,
                monthly_price: details.plan_monthly_price,
                annual_price: details.plan_annual_price,
                plan_price: details.plan_price,
                stripe_status: details.stripe_status,
                trial_ends_at: details.trial_ends_at,
                trial_eligible: details.trial_eligible,
                sms_allowed: details.sms_allowed,
                pending_plan_id: details.pending_plan_id,
                pending_plan_name: details.pending_plan_name,
                pending_plan_type: details.pending_plan_type,
                pending_change_at: details.pending_change_at,
                pending_change_kind: details.pending_change_kind,
              },
              planPeriodType:
                details.plan_period_type === "annual" ? "annual" : "monthly",
              admin: {
                id: details.id,
                first_name: details.first_name,
                last_name: details.last_name,
                username: details.username,
                email: details.email,
                phone: details.phone,
              },
              plans: [...response.data],
            },
          });
        })
        .catch((error) => {
          console.error(error);
        });

      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};

/**
 * get user details
 * @param {*} options
 * @returns
 */
export const getUserDetails = (options) => (dispatch) => {
  const { onSuccess, onError } = options || {};
  axios
    .get(`user-details/${getLoggedInUserId()}`)
    .then((res) => {
      const { data: resData } = res || {};
      const { data } = resData || {};
      if (onSuccess) {
        //const { venues } = data || {};
        onSuccess(data);
      }
    })
    .catch((err) => {
      if (onError) {
        onError(err);
      }
    });
};


